<template>
  <main-frame>
    <div slot="header">
      <el-form inline>
        <div @click="showDatePicker" v-show="!datePickerFocusIn">
          {{ date }}
        </div>
        <el-date-picker
          v-show="datePickerFocusIn"
          ref="datePicker"
          :editable="false"
          v-bind:value="date"
          :clearable="false"
          @blur="dateChange"
          @change="dateChange">
        </el-date-picker>
      </el-form>
    </div>
    <!-- <reservation-modal ref="reservationModal" @updated="fetchData" :dealerId="dealerId" /> -->
    <reservation-table
      @createReservation="createReservation"
      @editReservation="editReservation"
      v-loading="isLoading"
      :reservations="reservations"
      :shop="shop"
      :date="date"
      />
  </main-frame>
</template>

<script>
import moment from 'moment'
import MainFrame from '@/components/Layout/Frame'
import ReservationTable from './Table/Index'
import ReservationModal from './Modal'

export default {
  name: 'ReservationDashboard',
  components: {
    MainFrame,
    ReservationTable,
    ReservationModal,
  },
  props: {
    shopId: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      now: null,
      isLoading: false,
      datePickerFocusIn: false,
      shop: {
        pk: null,
        name: null,
      },
      shops: [],
      reservations: [],
    }
  },
  watch: {
    shopId () {
      this.fetchData()
    },
    date () {
      this.fetchData()
    },
  },
  craeted () {
    this.now = moment()
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    showDatePicker () {
      this.datePickerFocusIn = true
      this.$refs.datePicker.showPicker()
    },
    dateChange (e) {
      const date = moment(e.picker.date).locale('ja').format('YYYY-MM-DD')
      this.datePickerFocusIn = false
      if (date !== this.date) {
        this.$router.push({
          name: 'Dashboard',
          params: {
            shopId: this.shopId,
            date: date,
          },
        })
      }
    },
    fetchReservationData () {
      this.isLoading = true
      this.$request.reservations.list(this.shopId, this.date).then(res => {
        this.reservations = res.body.results
      }).finally(() => {
        this.isLoading = false
      })
    },
    createReservation (tick, liftId) {
      this.$refs.reservationModal.show(null, tick, liftId)
    },
    editReservation (reservationId) {
      this.$refs.reservationModal.show(reservationId)
    },
    fetchData () {
      this.fetchShopData()
      this.fetchReservationData()
    },
    fetchShopData () {
      this.$request.shops.get(this.shopId).then(res => {
        this.shop = res.body
      })
    },
    changeDealer () {
      this.shop = this.shops.find(x => x.id === this.shopId)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Index.vue